// extracted by mini-css-extract-plugin
export default {"pageBackground":"ExpandImageModal_pageBackground__z+gKA"};